import { getToken } from "api";
import axios from "axios";
import { ApiResponse } from "common/interfaces";
import { AppNotification } from "components/appNotification";
import { API_RESSOURCES } from "../teacher/teacher.routes";
import * as apiRoutes from "./studentReservation.routes";

/* export const findReservationStudent = async (idAds: string, values: any) => {
  try {
    const response = await axios.patch(apiRoutes.API_BASE_URL(idAds), values);
    return response.data;
  } catch (error: any) {
    if (error?.includes("status code 400")) {
      AppNotification(
        "Ce prof a déjà une réservation en cours.",
        "AlbertSad"
      );
    }
    throw error;
  }
}; */

export const findReservationStudent = async (idAds: string, values: any) => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  let attempt = 0;

  while (attempt < MAX_RETRIES) {
    try {
      const response = await axios.patch(apiRoutes.API_BASE_URL(idAds), values);
      return response.data;
    } catch (error: any) {
      attempt++;

      const status = error?.response?.status;
      const retryableStatusCodes = [429, 500, 502, 503, 504];

      // Handle known business logic error first
      if (status === 400) {
        AppNotification("Ce prof a déjà une réservation en cours.", "AlbertSad");
        throw error;
      }

      // If fatal or non-retryable or maxed out attempts
      if (!retryableStatusCodes.includes(status) || attempt >= MAX_RETRIES) {
        throw error;
      }

      const delay = Math.pow(2, attempt) * 200;
      console.warn(`Retrying findReservationStudent (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
      await sleep(delay);
    }
  }
};

export const findReservationOrganism = async (idAds: string, values: any) => {
  const MAX_RETRIES = 5;

  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  let attempt = 0;

  while (attempt < MAX_RETRIES) {
    try {
      const response = await axios.post(apiRoutes.API_BASE_URL_ORGANISM(idAds), values);
      return response.data;
    } catch (error: any) {
      attempt++;

      const status = error?.response?.status;
      const retryableStatusCodes = [429, 500, 502, 503, 504];

      // Handle known business logic error first
      if (status === 400) {
        AppNotification("Ce prof a déjà une réservation en cours.", "AlbertSad");
        throw error;
      }

      // If fatal or non-retryable or maxed out attempts
      if (!retryableStatusCodes.includes(status) || attempt >= MAX_RETRIES) {
        throw error;
      }

      const delay = Math.pow(2, attempt) * 200;
      console.warn(`Retrying findReservationStudent (${attempt}/${MAX_RETRIES}) in ${delay}ms...`);
      await sleep(delay);
    }
  }
};

export const findProgrammeStudent = async (studentId: string | any) => {
  try {
    const response = await axios.get(apiRoutes.API_BASE_URL_ADS(studentId));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBookingData = async (
  studId: string,
): Promise<ApiResponse | undefined> => {
  try {
    const token = await getToken();
    if (!token) throw new Error("access token not valid");
    const response = await axios.get(`${API_RESSOURCES}/advertisements/fetch/Reservations?studId=${studId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
